'use client';

import {
  ModuleRegistry,
  AllCommunityModule,
  ServerSideRowModelModule,
  ServerSideRowModelApiModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  MenuModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  IntegratedChartsModule,
  ClipboardModule,
  CalculatedColumnsModule,
  ShowValuesAsModule,
} from 'ag-grid-enterprise';
import { enableDevValidations } from 'ag-grid-community';
import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';

if (process.env.NODE_ENV !== 'production') {
  enableDevValidations();
}

// This happens once at module load time, not at render time
ModuleRegistry.registerModules([
  AllCommunityModule,
  ServerSideRowModelModule,
  ServerSideRowModelApiModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  MenuModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  ClipboardModule,
  CalculatedColumnsModule,
  ShowValuesAsModule,
  IntegratedChartsModule.with(AgChartsEnterpriseModule),
]);
